import { useTranslation } from '@framework/i18n';
import { DividerTitleElement, VerticalSpace } from '@framework/ui';
import React from 'react';

export interface IDesktopFilterPanelProps {
  children?: React.ReactNode;
}

/**
 * Pannello.
 */
export function DesktopFilterPanel(props: IDesktopFilterPanelProps) {
  const { children } = props;
  const { t } = useTranslation();

  const title = t(
    'collapse.desktop-filter-panel.title',
    'Filtri di ricerca estesi',
  );

  return (
    <>
      <h3 className="sr-only">{title}</h3>
      <div aria-hidden="true">
        <DividerTitleElement title={title} removeTopMargin />
      </div>
      {children}
      <VerticalSpace size={6} />
    </>
  );
}
